import consumer from './consumer'

const subscribeToScanRun = (scanRunId, callbacks) => consumer.subscriptions.create(
  { channel: 'NegativeKeywordScanChannel', scan_run_id: scanRunId },
  {
    connected: () => callbacks.onConnect?.(),
    disconnected: () => callbacks.onDisconnect?.(),
    received: (data) => callbacks.onMessage?.(data)
  }
)

export default subscribeToScanRun
export { subscribeToScanRun }
